import { render, staticRenderFns } from "./List.vue?vue&type=template&id=674c33bb"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('674c33bb')) {
      api.createRecord('674c33bb', component.options)
    } else {
      api.reload('674c33bb', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=674c33bb", function () {
      api.rerender('674c33bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/List.vue"
export default component.exports